<template>
  <div class="step-description step-description__wrapper" :id="getId()" @click="onClick()">
    <div class="step-description step-description__number"><div class="step-description__circle"><span>{{ order }}</span></div></div>
    <div class="step-description step-description__text">
      <h2 class="step-description step-description__title" :class="[( hasChosenProducts ) ? 'step-description__title--checkmark' : '']">{{ store.methods.getText(endpoint, "title") }}</h2>
    </div>
    <div class="step-description step-description__arrow-wrapper"><i class="step-description step-description__arrow" :class= "show ? 'step-description__arrow--up' : '' "></i></div>
  </div>
</template>

<script>

import { inject } from 'vue';

export default {
  name: 'StepDescription',
  setup() {
    const store = inject('store');

    return {
      store
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    onClick() {
      this.show = !this.show;
      this.$emit('clicked', this.show)
      if (this.show == true) {
        setTimeout(this.scrollToId, 100)
      }
    },
    getId() {
      let id = "#" + this.endpoint;
      return id;
    },
    scrollToId() {
        document.getElementById("#"+this.endpoint).scrollIntoView({
            behavior: "smooth"
        });
    },
  },
  mounted() {
    if (this.order == 1) {
      this.show = true;
    }
  },
  props: {
    order: Number,
    title: String,
    hasChosenProducts: Boolean,
    endpoint: String
  }
}
</script>
